// extracted by mini-css-extract-plugin
export default {"label":"Label_label__MkQJa","breathing":"Label_breathing__wqkxr"};